import { render, staticRenderFns } from "./NFCGuide.vue?vue&type=template&id=30e3c8d6&scoped=true&"
import script from "./NFCGuide.vue?vue&type=script&lang=js&"
export * from "./NFCGuide.vue?vue&type=script&lang=js&"
import style0 from "./NFCGuide.vue?vue&type=style&index=0&id=30e3c8d6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3c8d6",
  null
  
)

export default component.exports